import posthog from 'posthog-js'
import {useUtils} from "@/composables/useUtils.ts";

const apiKey = import.meta.env.VITE_APP_POSTHOG_API_KEY;
// Inicializamos fora da função para garantir que seja um Singleton
// (evita inicializar o PostHog toda vez que o composable for chamado)
if (apiKey) {
  posthog.init(apiKey, {
    api_host: 'https://us.i.posthog.com',
    person_profiles: 'identified_only',
    capture_pageview: false
  })
}

export function usePostHog() {
  return { posthog }
}
